export class Emitter {
    onHandlerError;
    listeners = new Map();
    constructor(onHandlerError) {
        this.onHandlerError = onHandlerError;
    }
    on(event, listener) {
        let set = this.listeners.get(event);
        if (!set) {
            set = new Set();
            this.listeners.set(event, set);
        }
        set.add(listener);
        return () => {
            this.off(event, listener);
        };
    }
    once(event, listener) {
        const wrapper = (payload) => {
            this.off(event, wrapper);
            listener(payload);
        };
        return this.on(event, wrapper);
    }
    off(event, listener) {
        const set = this.listeners.get(event);
        if (!set)
            return;
        set.delete(listener);
        if (set.size === 0)
            this.listeners.delete(event);
    }
    emit(event, payload) {
        const set = this.listeners.get(event);
        if (!set || set.size === 0)
            return;
        for (const listener of [...set]) {
            try {
                listener(payload);
            }
            catch (error) {
                this.onHandlerError?.(error, event);
            }
        }
    }
    removeAll(event) {
        if (event === undefined)
            this.listeners.clear();
        else
            this.listeners.delete(event);
    }
    count(event) {
        if (event !== undefined)
            return this.listeners.get(event)?.size ?? 0;
        let total = 0;
        for (const set of this.listeners.values())
            total += set.size;
        return total;
    }
}
//# sourceMappingURL=emitter.js.map